import { defineStore } from "pinia";
import { useDisplay } from "vuetify";
import { computed } from "vue";

export const useDisplayStore = defineStore("display", () => {
  const display: any = useDisplay();

  /*
lg = 1280px and up
md = 960px - 1264px
sm = 600px - 959px
xs = 0px - 599px
*/

  const isMobile = computed(() => display.xs.value); // 0–599 px
  const isTablet = computed(() => display.sm.value); // 600–959 px
  const isDesktop = computed(() => display.mdAndUp.value); // ≥ 960 px

  return { display, isMobile, isTablet, isDesktop };
});
